import { render, staticRenderFns } from "./TransportFormMenu.vue?vue&type=template&id=4a48fb62&"
import script from "./TransportFormMenu.vue?vue&type=script&lang=js&"
export * from "./TransportFormMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports